import apiHelper from '../../helper/ApiHelper';

const AdminLedgerService = {

  async getLedgers() {
    try {
      return await apiHelper('/admin/ledgers');
    } catch (error) {
      console.error('Error fetching heads:', error);
      throw error;
    }
  },
  async getLedgerDetails(ledgerId) {
    try {
      return await apiHelper(`/admin/ledgers/${ledgerId}`);
    } catch (error) {
      console.error('Error fetching ledger details:', error);
      throw error;
    }
  },
};

export default AdminLedgerService;